// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag-management-page {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
}

.tag-management-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.tag-management-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 2px solid #e0e0e0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.tag-management-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: white;
}

.back-button {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.back-button:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.error-message {
  margin: 16px 24px;
  padding: 12px;
  background: #ffebee;
  color: #d32f2f;
  border-radius: 6px;
  border: 1px solid #ffcdd2;
}

.tag-management-content {
  display: flex;
  min-height: 500px;
}

.tag-form-section {
  flex: 1 1;
  padding: 24px;
  border-right: 2px solid #e0e0e0;
  overflow-y: auto;
}

.tag-form-section h3 {
  margin-top: 0;
  color: #333;
  font-size: 1.2rem;
}

.tag-list-section {
  flex: 1 1;
  padding: 24px;
  overflow-y: auto;
}

.tag-list-section h3 {
  margin-top: 0;
  color: #333;
  font-size: 1.2rem;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.form-group input[type="text"],
.form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 0.9rem;
  font-family: inherit;
  box-sizing: border-box;
}

.form-group input[type="text"]:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
}

.checkbox-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.checkbox-group input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.color-picker {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
  margin-bottom: 12px;
}

.color-option {
  width: 100%;
  aspect-ratio: 1;
  border: 3px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.color-option:hover {
  transform: scale(1.1);
}

.color-option.selected {
  border-color: #667eea;
  box-shadow: 0 0 0 2px white, 0 0 0 4px #667eea;
}

.color-preview {
  margin-top: 12px;
}

.color-preview-badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 16px;
  color: white;
  font-weight: 500;
  font-size: 0.9rem;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.btn-primary,
.btn-secondary {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary {
  background: #667eea;
  color: white;
}

.btn-primary:hover {
  background: #5568d3;
}

.btn-secondary {
  background: #e0e0e0;
  color: #333;
}

.btn-secondary:hover {
  background: #d0d0d0;
}

.tag-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tag-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
}

.tag-badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 16px;
  color: white;
  font-weight: 500;
  font-size: 0.85rem;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  flex-shrink: 0;
}

.tag-info {
  flex: 1 1;
  min-width: 0;
}

.tag-description {
  color: #666;
  font-size: 0.85rem;
  margin-bottom: 4px;
}

.tag-group {
  color: #888;
  font-size: 0.8rem;
  margin-bottom: 4px;
}

.tag-meta {
  color: #999;
  font-size: 0.75rem;
}

.tag-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.btn-edit,
.btn-delete {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-edit {
  background: #667eea;
  color: white;
}

.btn-edit:hover {
  background: #5568d3;
}

.btn-delete {
  background: #d32f2f;
  color: white;
}

.btn-delete:hover {
  background: #b71c1c;
}

.delete-disabled {
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.85rem;
  color: #999;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  cursor: not-allowed;
  font-style: italic;
}

.loading,
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}

/* Delete Confirmation Dialog */
.delete-confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.delete-confirm-dialog {
  background: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 600px;
  width: 100%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.delete-confirm-dialog h3 {
  margin: 0 0 16px 0;
  color: #d32f2f;
  font-size: 1.3rem;
}

.delete-confirm-dialog p {
  margin: 0 0 16px 0;
  color: #333;
  line-height: 1.5;
}

.delete-confirm-dialog p strong {
  color: #d32f2f;
}

.no-trades-message {
  color: #666;
  font-style: italic;
  margin: 12px 0;
}

.connected-trades-list {
  margin: 16px 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  background: #fafafa;
}

.connected-trades-list h4 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 1rem;
}

.trades-scroll-container {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 8px;
}

.trades-scroll-container ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.trades-scroll-container li {
  padding: 8px 12px;
  margin-bottom: 8px;
  background: white;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  font-size: 0.9rem;
  line-height: 1.4;
}

.trades-scroll-container li strong {
  color: #667eea;
}

.trade-date {
  color: #666;
  font-size: 0.85rem;
}

.trade-account {
  color: #999;
  font-size: 0.85rem;
}

.more-trades {
  font-style: italic;
  color: #666;
  background: #f5f5f5 !important;
}

.delete-confirm-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.btn-delete-confirm,
.btn-cancel {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-delete-confirm {
  background: #d32f2f;
  color: white;
}

.btn-delete-confirm:hover {
  background: #b71c1c;
}

.btn-cancel {
  background: #e0e0e0;
  color: #333;
}

.btn-cancel:hover {
  background: #d0d0d0;
}

@media (max-width: 768px) {
  .tag-management-content {
    flex-direction: column;
  }

  .tag-form-section {
    border-right: none;
    border-bottom: 2px solid #e0e0e0;
  }

  .color-picker {
    grid-template-columns: repeat(4, 1fr);
  }

  .delete-confirm-dialog {
    max-width: 100%;
    margin: 10px;
  }

  .delete-confirm-actions {
    flex-direction: column;
  }

  .btn-delete-confirm,
  .btn-cancel {
    width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/TagManagement.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".tag-management-page {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0;\n}\n\n.tag-management-container {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.tag-management-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 2px solid #e0e0e0;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.tag-management-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: white;\n}\n\n.back-button {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  padding: 8px 16px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.back-button:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.error-message {\n  margin: 16px 24px;\n  padding: 12px;\n  background: #ffebee;\n  color: #d32f2f;\n  border-radius: 6px;\n  border: 1px solid #ffcdd2;\n}\n\n.tag-management-content {\n  display: flex;\n  min-height: 500px;\n}\n\n.tag-form-section {\n  flex: 1;\n  padding: 24px;\n  border-right: 2px solid #e0e0e0;\n  overflow-y: auto;\n}\n\n.tag-form-section h3 {\n  margin-top: 0;\n  color: #333;\n  font-size: 1.2rem;\n}\n\n.tag-list-section {\n  flex: 1;\n  padding: 24px;\n  overflow-y: auto;\n}\n\n.tag-list-section h3 {\n  margin-top: 0;\n  color: #333;\n  font-size: 1.2rem;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n}\n\n.form-group input[type=\"text\"],\n.form-group textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n.form-group input[type=\"text\"]:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.checkbox-group label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.color-picker {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.color-option {\n  width: 100%;\n  aspect-ratio: 1;\n  border: 3px solid transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: transform 0.2s ease, border-color 0.2s ease;\n}\n\n.color-option:hover {\n  transform: scale(1.1);\n}\n\n.color-option.selected {\n  border-color: #667eea;\n  box-shadow: 0 0 0 2px white, 0 0 0 4px #667eea;\n}\n\n.color-preview {\n  margin-top: 12px;\n}\n\n.color-preview-badge {\n  display: inline-block;\n  padding: 6px 12px;\n  border-radius: 16px;\n  color: white;\n  font-weight: 500;\n  font-size: 0.9rem;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.btn-primary,\n.btn-secondary {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-primary {\n  background: #667eea;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #5568d3;\n}\n\n.btn-secondary {\n  background: #e0e0e0;\n  color: #333;\n}\n\n.btn-secondary:hover {\n  background: #d0d0d0;\n}\n\n.tag-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.tag-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  background: #fafafa;\n}\n\n.tag-badge {\n  display: inline-block;\n  padding: 6px 12px;\n  border-radius: 16px;\n  color: white;\n  font-weight: 500;\n  font-size: 0.85rem;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.tag-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.tag-description {\n  color: #666;\n  font-size: 0.85rem;\n  margin-bottom: 4px;\n}\n\n.tag-group {\n  color: #888;\n  font-size: 0.8rem;\n  margin-bottom: 4px;\n}\n\n.tag-meta {\n  color: #999;\n  font-size: 0.75rem;\n}\n\n.tag-actions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.btn-edit,\n.btn-delete {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-edit {\n  background: #667eea;\n  color: white;\n}\n\n.btn-edit:hover {\n  background: #5568d3;\n}\n\n.btn-delete {\n  background: #d32f2f;\n  color: white;\n}\n\n.btn-delete:hover {\n  background: #b71c1c;\n}\n\n.delete-disabled {\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  color: #999;\n  background: #f5f5f5;\n  border: 1px solid #e0e0e0;\n  cursor: not-allowed;\n  font-style: italic;\n}\n\n.loading,\n.empty-state {\n  text-align: center;\n  padding: 40px 20px;\n  color: #666;\n}\n\n/* Delete Confirmation Dialog */\n.delete-confirm-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.delete-confirm-dialog {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  max-width: 600px;\n  width: 100%;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.delete-confirm-dialog h3 {\n  margin: 0 0 16px 0;\n  color: #d32f2f;\n  font-size: 1.3rem;\n}\n\n.delete-confirm-dialog p {\n  margin: 0 0 16px 0;\n  color: #333;\n  line-height: 1.5;\n}\n\n.delete-confirm-dialog p strong {\n  color: #d32f2f;\n}\n\n.no-trades-message {\n  color: #666;\n  font-style: italic;\n  margin: 12px 0;\n}\n\n.connected-trades-list {\n  margin: 16px 0;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 12px;\n  background: #fafafa;\n}\n\n.connected-trades-list h4 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 1rem;\n}\n\n.trades-scroll-container {\n  max-height: 300px;\n  overflow-y: auto;\n  padding-right: 8px;\n}\n\n.trades-scroll-container ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.trades-scroll-container li {\n  padding: 8px 12px;\n  margin-bottom: 8px;\n  background: white;\n  border-radius: 6px;\n  border: 1px solid #e0e0e0;\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n.trades-scroll-container li strong {\n  color: #667eea;\n}\n\n.trade-date {\n  color: #666;\n  font-size: 0.85rem;\n}\n\n.trade-account {\n  color: #999;\n  font-size: 0.85rem;\n}\n\n.more-trades {\n  font-style: italic;\n  color: #666;\n  background: #f5f5f5 !important;\n}\n\n.delete-confirm-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.btn-delete-confirm,\n.btn-cancel {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-delete-confirm {\n  background: #d32f2f;\n  color: white;\n}\n\n.btn-delete-confirm:hover {\n  background: #b71c1c;\n}\n\n.btn-cancel {\n  background: #e0e0e0;\n  color: #333;\n}\n\n.btn-cancel:hover {\n  background: #d0d0d0;\n}\n\n@media (max-width: 768px) {\n  .tag-management-content {\n    flex-direction: column;\n  }\n\n  .tag-form-section {\n    border-right: none;\n    border-bottom: 2px solid #e0e0e0;\n  }\n\n  .color-picker {\n    grid-template-columns: repeat(4, 1fr);\n  }\n\n  .delete-confirm-dialog {\n    max-width: 100%;\n    margin: 10px;\n  }\n\n  .delete-confirm-actions {\n    flex-direction: column;\n  }\n\n  .btn-delete-confirm,\n  .btn-cancel {\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
